import React, { useState } from "react";
import { CostingItem } from "../../interfaces/app_types";

interface CostingBulkModalBodyProps {
  onBulkStage: (items: CostingItem[]) => void;
}

const CostingBulkModalBody = ({ onBulkStage }: CostingBulkModalBodyProps) => {
  const [file, setFile] = useState<File | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];

    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const parseReadme = (content: string): CostingItem[] => {
    const lines = content.split(/\r?\n/);

    const items: CostingItem[] = [];

    for (const line of lines) {
      const trimmedLine = line.trim();

      // Ignore blank lines
      if (!trimmedLine) {
        continue;
      }

      // Ignore header
      if (trimmedLine.startsWith("| File |")) {
        continue;
      }

      // Ignore markdown separator
      if (trimmedLine.match(/^\|\s*-+/)) {
        continue;
      }

      // Only process table rows
      if (!trimmedLine.startsWith("|")) {
        continue;
      }

      // Split row into columns
      const columns = trimmedLine
        .split("|")
        .map((column) => column.trim())
        .filter(Boolean);

      // We expect:
      // File | Description | Drg No | Rev | Length | Breadth | Thickness | Fallback Used
      if (columns.length < 8) {
        continue;
      }

      const [
        fileName,
        description,
        drgNo,
        revision,
        length,
        breadth,
        thickness,
        fallbackUsed,
      ] = columns;

      const item: CostingItem = {
        part_name: description,
        drawing_no: drgNo,

        length: length === "-" ? "" : Number(length),
        breadth: breadth === "-" ? "" : Number(breadth),
        thickness: thickness === "-" ? "" : Number(thickness),

        raw_material_rate: 69,
        laser_rate: "",
        quantity: 10,

        operations: [],
        tools: [],
      };

      items.push(item);
    }

    return items;
  };

  const handleAccept = async () => {
    if (!file) {
      return;
    }

    try {
      const content = await file.text();
      const items = parseReadme(content);

      if (items.length === 0) {
        console.error("No costing items found in README");
        return;
      }

      onBulkStage(items);

      // Clear selected file
      setFile(null);

      // Close Bootstrap modal
      const modalElement = document.getElementById("bulkCostingModal");

      if (modalElement) {
        const bootstrapModal = (window as any).bootstrap?.Modal.getInstance(
          modalElement
        );

        bootstrapModal?.hide();
      }
    } catch (error) {
      console.error("Failed to process README:", error);
    }
  };

  const handleCancel = () => {
    setFile(null);

    // Close Bootstrap modal
    const modalElement = document.getElementById("costingBulkModal");

    if (modalElement) {
      const bootstrapModal = (window as any).bootstrap?.Modal.getInstance(
        modalElement
      );

      bootstrapModal?.hide();
    }
  };

  return (
    <div>
      <div>
        <div className="mb-3">
          <input
            type="file"
            className="form-control"
            accept=".txt,.md"
            onChange={handleFileChange}
          />
        </div>

        <div className="mt-5">
          <h3 className="text-center">Guidelines</h3>

          <ul>
            <li>Start Ollama App on your desktop</li>
            <li>Run the Python script on the target folder</li>
            <li>Add README file here and Accept</li>
            <li>
              Make sure that columns in frontend code and readME both match
            </li>
          </ul>
        </div>
      </div>

      <div className="d-flex justify-content-end gap-2">
        <button
          type="button"
          className="styled-btn--dark"
          onClick={handleAccept}
          disabled={!file}
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CostingBulkModalBody;
